import axios from 'axios';

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  validateStatus: (status) => status >= 200 && status < 400,
});

// Login endpoints must not send Authorization: many APIs treat any
// Authorization header (including empty) as JWT/basic auth and return 401
// before validating email/password. Postman typically omits this header.
axiosClient.interceptors.request.use((requestConfig) => {
  const url = requestConfig.url || '';
  const isPublicLogin =
    url.includes('auth/login-intranet') || url.includes('auth/login-extranet');

  if (!isPublicLogin || !requestConfig.headers) {
    return requestConfig;
  }

  const headers = { ...requestConfig.headers };
  delete headers.Authorization;
  delete headers.authorization;

  if (headers.common) {
    headers.common = { ...headers.common };
    delete headers.common.Authorization;
    delete headers.common.authorization;
  }

  return { ...requestConfig, headers };
});

export const axiosAnything = axios.create({
  validateStatus: (status) => status >= 200 && status < 400,
});

export default axiosClient;
